import React, { FC, useEffect, useState } from 'react';
import { useFindSimiliarSportingEventsLazyQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';
import useDebouncedSearch from '../hooks/useDebouncedSearch';

interface SportingEvents extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
  filter?: any;
}

const SportEvents: FC<SportingEvents> = ({ label, error, control, name, rules, filter }) => {
  const [fetch, { data, loading, refetch }] = useFindSimiliarSportingEventsLazyQuery({
    variables: { search: '', ...filter },
  });
  const [parsed, setParsed] = useState<any>([]);

  const refetchSportingEvents = async (value: string) => {
    if (value?.length > 2) {
      await fetch({ variables: { search: value, ...filter } });
    }
  };
  const useSearchSportingEvents = () => useDebouncedSearch((text) => refetchSportingEvents(text));

  const { setInputValue: setValue } = useSearchSportingEvents();

  useEffect(() => {
    if (!loading) {
      const prepare = data?.dirSportingEvents;
      setParsed(prepare || []);
    }
  }, [data, loading]);

  return (
    <Select
      enablePortal
      label={label}
      data={parsed}
      control={control}
      error={error}
      name={name}
      rules={rules}
      onChangeInput={setValue}
      loading={loading}
    />
  );
};

export default SportEvents;
